import { MessageType } from '@entities/post/model/types'
// TODO нарушение fsd, поправить

export const getMessageType = (file: File): MessageType | undefined => {
    if (file?.type) {
        const mimeType = file.type
        if (mimeType.startsWith('image') || mimeType.startsWith('photo')) {
            return MessageType.PHOTO
        } else if (mimeType.startsWith('video')) {
            return MessageType.PHOTO
        } else if (mimeType.startsWith('application')) {
            return MessageType.DOCUMENT
        } else if (mimeType.startsWith('audio')) {
            return MessageType.AUDIO
        }
        return undefined
    }
    return undefined
}
